<template>
  <div class="section-sub-teams" id="section-sub-teams" data-aos="fade-up" data-aos-once="true">

    <!-- header -->
    <page-subheader :title="title"></page-subheader>

    <div-container>
      <!-- <div class="columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile">
        <div class="column is-11 is-12-mobile has-text-centered content" style="padding-bottom:0;">
          <img src="../assets/full_stamp.svg" width="220" class="max-width:100%;" />
        </div>
      </div> -->
      <div class="columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile">
        <div class="column is-11 is-12-mobile has-text-centered content content-competitions">
          <span v-for="competition in competitions" class="wrapper">
            <a :href="$route.path + '?team=' + competition.name_slug" @click="onClickTeam($event, competition.name_slug)">
              <img :src="competition.image.path" style="display:inline-block;padding:5px;vertical-align:middle;width:40px;max-height:50px;" />
              <h3 style="display:inline-block;padding:3px 16px;"><span class="name" :class="{ 'is-active': (competition.name_slug === filter) }">{{ competition.name }}</span></h3><br />
            </a>
          </span>
        </div>
        <div v-if="teams" class="column is-11 is-12-mobile has-text-centered content content-teams" style="padding-top:0;">
          <div v-for="(team, index) in teams" :key="team.name_slug" v-if="!team.hide" class="columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile" :class="{ 'is-alt': team.isAlt }">
            <div class="column is-8 has-text-centered">
              <!-- <img :src="team.image.path" style="display:inline-block;padding:5px;vertical-align:middle;" /> -->
              <h3 style="display:inline-block;padding:16px 0px;margin-bottom:0;">{{ team.name }}</h3>&nbsp;<h4 style="display:inline-block;padding:16px 8px;margin-bottom:0;font-weight:normal;">({{ team.city }}, {{ team.state }})</h4><br />
            </div>
            <div v-if="team.competitions" class="column is-4 has-text-centered">
              <img v-for="competition in team.competitions" :src="competition.image.path" style="display:inline-block;padding:5px;vertical-align:middle;width:40px;max-height:50px;" />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="control notification is-danger" v-if="error">
        <button class="delete" @click="error = undefined"></button>
        <p v-html="error">
        </p>
      </div> -->

    </div-container>
  </div>
</template>

<script>
import Site from '@/apis/Site'
import DivContainer from '@/components/DivContainer'
import PageSubheader from '@/components/PageSubheader'
// import ShowDown from 'showdown'
// import 'showdown-target-blank'
import ImgAllTeam from '@/assets/icon-teams.png'

export default {
  name: 'sub-teams',
  props: ['title'],
  components: {
    DivContainer,
    PageSubheader
  },
  data () {
    return {
      competitions: [],
      teams: [],
      filter: undefined,
      error: undefined,
      loading: false
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    getAll: function () {
      this.loading = true
      this.error = undefined
      Site.competition()
      .then((data) => {
        this.loading = false
        // console.log(data)
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return Site.team()
        }
        this.onCompetitionComplete(data)
        return Site.team()
      })
      .then((data) => {
        if (!data) {
          this.error = 'Unable to load, please kindly refresh the page.'
          return
        }
        this.onTeamComplete(data)
      })
      .catch((error) => {
        this.loading = false
        this.error = 'Unable to load, please kindly refresh the page.'
        console.log(error)
      })
    },

    onCompetitionComplete: function (competitions) {
      var allTeam = {
        name: 'All Teams',
        name_slug: 'all-teams',
        image: {
          path: ImgAllTeam
        }
      }
      competitions = [allTeam].concat(competitions)
      this.competitions = competitions
    },

    onTeamComplete: function (teams) {
      // assemble competitions from key into groups
      var teamKeys = []
      for (var i = 1; i <= 9; i++) {
        teamKeys.push('team_' + i)
      }

      var countAlt = 0
      for (var j = 0; j < teams.length; j++) {
        var team = teams[j]

        team.hide = false
        team.isAlt = (countAlt % 2 !== 0)
        countAlt++

        // consolidate competitions for each team
        team.competitions = {}
        for (var k = 0; k < teamKeys.length; k++) {
          var teamKey = teamKeys[k]
          if (team[teamKey]) {
            team.competitions[team[teamKey].name_slug] = team[teamKey]
          }
        }
      }
      this.teams = teams
    },

    refresh: function () {
      this.getAll()
    },

    onClickTeam: function ($event, teamSlug) {
      $event.preventDefault()
      this.filterTeam(teamSlug)
    },

    filterNone: function () {
      this.filter = undefined
      var countAlt = 0
      for (var i = 0; i < this.teams.length; i++) {
        var team = this.teams[i]
        team.hide = false
        team.isAlt = (countAlt % 2 !== 0)
        countAlt++
      }
    },

    filterTeam: function (teamSlug) {
      // toggle to clear (default to all-teams)
      if (this.filter !== undefined && this.filter.length > 0 && this.filter === teamSlug) {
        this.filterNone()
        return
      }

      // default all filter
      if (!teamSlug) {
        this.filterNone()
        return
      }

      if (teamSlug === 'all-teams') {
        this.filterNone()
        return
      }

      // filter based on team slug
      this.filter = teamSlug
      var countAlt = 0
      for (var i = 0; i < this.teams.length; i++) {
        var team = this.teams[i]
        if (team.competitions && team.competitions[teamSlug]) {
          team.hide = false
          team.isAlt = (countAlt % 2 !== 0)
          countAlt++
        } else {
          team.hide = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// section sub teams

.section-sub-teams {
  padding-top: 3rem;
  padding-bottom: 3rem;

  .title:not(:last-child),
  .subtitle:not(:last-child) {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 0.1em;
  }

  .title:last-child,
  .subtitle:last-child {
    padding-left: 0.75em;
    padding-right: 0.75em;
    margin-bottom: 1em;
  }

  p {
    font-size: 1em;
    text-align: left;
    padding-left: 0.75em;
    padding-right: 0.75em;

    &:not(:first-child) {
      margin-top: 1em;
      @media screen and (min-width: $tablet) {
        margin-top: 1em;
      }
    }
  }

  .columns.is-gapless:not(:last-child) {
    margin-bottom: 0;
  }

  .columns.is-gapless > .column {
    &.content {
      background-color: white;
      padding: 50px 30px;

      &-competitions, &-teams {
        @media screen and (min-width: $tablet) {
          padding: 50px 80px;
        }

        &.with-image {
          padding-top: 0;
        }

        .is-alt {
          background-color: $color-beige;
        }

        img {
          display: block;
          margin-left: auto;
          margin-right: auto;
        }

        p, li, h1, h2, h3, h4, h5, h6, strong {
          color: $color-darkbrown;
        }

        p, li {
          line-height: 2.2em;
        }

        h1, h2, h3, h4, h5, h6 {
          font-family: $font-family-title;
          font-weight: bold;
          text-transform: uppercase;

          // &:not(:first-child) {
          //   margin-top: 2rem;
          // }
          // margin-bottom: 1rem;
          //
          // @media screen and (min-width: $tablet) {
          //   &:not(:first-child) {
          //     margin-top: 3rem;
          //   }
          //   margin-bottom: 2rem;
          // }

          &:not(:first-child) {
            margin-top: 0;
          }

          a {
            margin-left: 30px;
          }
        }

        // h1, h2 {
        //   &:not(:first-child) {
        //     margin-top: 3rem;
        //   }
        // }
      }

      &-competitions {
        .wrapper {
          .name {
            padding: 3px 5px;
            border-bottom: 1px solid gray;

            &.is-active {
            background-color: $color-beige;
            }
          }
        }
      }
    }
  }

  ul {
    list-style: disc;
    margin-left: 2em;
  }
}

</style>



// WEBPACK FOOTER //
// TeamsSubSection.vue?396027a1